import { render } from "./TopDonators.vue?vue&type=template&id=922f4362&scoped=true"
import script from "./TopDonators.vue?vue&type=script&lang=js"
export * from "./TopDonators.vue?vue&type=script&lang=js"

import "./TopDonators.vue?vue&type=style&index=0&id=922f4362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922f4362"]])

export default __exports__